import React, { useState } from 'react';
import {
  Title2,
  Body1,
  Tab,
  TabList,
  type SelectTabData,
  type SelectTabEvent,
} from '@fluentui/react-components';
import { useProgramChangesPageStyles } from '../styles/ProgramChangesPage.styles';
import { useSubmissionWindow } from '../hooks/useSubmissionWindow';
import { MarketCategoriesTab } from './ProgramChanges/MarketCategoriesTab';
import { BenefitsPerTierTab } from './ProgramChanges/BenefitsPerTierTab';
import { ThresholdsByMarketTab } from './ProgramChanges/ThresholdsByMarketTab';
import { MarketCategoriesProvider } from '../contexts/MarketCategoriesContext';
import { BenefitsPerTierProvider } from '../contexts/BenefitsPerTierContext';

type TabId = 'market-categories' | 'benefits-per-tier' | 'thresholds-by-market';

export const ProgramChangesPage: React.FC = () => {
  const styles = useProgramChangesPageStyles();
  const [selectedTab, setSelectedTab] = useState<TabId>('market-categories');
  const { isWindowOpen } = useSubmissionWindow();
  const isLocked = !isWindowOpen;

  const handleTabSelect = (_event: SelectTabEvent, data: SelectTabData) => {
    setSelectedTab(data.value as TabId);
  };

  const renderTabContent = () => {
    switch (selectedTab) {
      case 'market-categories':
        return <MarketCategoriesTab isLocked={isLocked} />;
      case 'benefits-per-tier':
        return <BenefitsPerTierTab isLocked={isLocked} />;
      case 'thresholds-by-market':
        return <ThresholdsByMarketTab isLocked={isLocked} />;
      default:
        return null;
    }
  };

  return (
    <MarketCategoriesProvider>
      <BenefitsPerTierProvider>
      <div>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <Title2>Program changes</Title2>
          <Body1>
            Report will be refreshed on the 1st working day of next month.
          </Body1>
          { /*  
           // Show lock status and edit window in case is need it in the future, for now we are not showing it in the UI
           <div className={styles.statusRow}>
            {isLocked ? (
              <Badge appearance="filled" color="danger" icon={<LockClosedRegular />}>
                LOCKED — VIEW ONLY
              </Badge>
            ) : (
              <Badge appearance="filled" color="success" icon={<LockOpenRegular />}>
                UNLOCKED — EDITS AVAILABLE
              </Badge>
            )}
            <div className={styles.lastUpdated}>
              <ClockRegular />
              <Text size={200}>
                Edit window: {formatWindowDate(windowStart)} – {formatWindowDate(windowEnd)}
              </Text>
            </div> 
          </div> */ }
        </div>
      </div>

      <TabList selectedValue={selectedTab} onTabSelect={handleTabSelect}>
        <Tab value="market-categories">Market categories</Tab>
        <Tab value="benefits-per-tier">Benefits per tier</Tab>
        <Tab value="thresholds-by-market">Thresholds by market</Tab>
      </TabList>

      <div className={styles.tabContent}>
        {renderTabContent()}
      </div>
    </div>
    </BenefitsPerTierProvider>
    </MarketCategoriesProvider>
  );
};
